import React from 'react';
import { connect } from 'react-redux';
import ClientSidebar from '../components/Element/ClientSidebar';
import Appoinments from '../components/Element/Appoinments';
const JobAssesment = (props) => {
	return (
		<React.Fragment>
			<div className="page-content bg-white">
				<div className="content-block">
					<div className="section-full bg-white browse-job p-t50 p-b20">
						<div className="container">
							<div className="row">
								<ClientSidebar page="job-assesments"/>
								<div className="col-xl-9 col-lg-8 m-b30 m-t30">
									<Appoinments />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	)
}


const mapStateToProps = (state) => {
  return {
    userAuth:state.auth.authUserdata
  }
}

export default connect(mapStateToProps)(JobAssesment);